<div class="driver-modal">
  <div class="sec_head">
    <h2>{{ 'AssignTeam' | translate }}</h2>
    <button class="close-btn" (click)="dialogueClose('')" type="button">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div class="modal-body">
    <div id="page-content-wrapper">
      <mat-select
        size="6"
        (selectionChange)="onSelectionChange($event, data.data)"
        placeholder="{{ 'SelectAnEntireTeams' | translate }}"
        class="form_control">
        <mat-option
          *ngFor="let data of dataSource"
          [value]="data"
          (click)="afterTeamSelect(data._id)"
          >{{ data.teamName | titlecase }}</mat-option
        >
      </mat-select>
    </div>
    <div *ngIf="data.type === 'driver'" class="modal-body">
      <div class="sec_head">
        <h2>{{ 'AssignAParticularDriver' | translate }}</h2>
      </div>
      <div id="page-content-wrapper">
        <mat-select
          placeholder="{{ 'SelectDriver' | translate }}"
          class="form_control">
          <mat-option
            *ngFor="let data of driverList"
            (click)="onDriverSelected(data.driverId._id)">
            {{ data.driverId.name | titlecase }}
          </mat-option>
        </mat-select>
      </div>
    </div>
  </div>
</div>
